<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M6.52734 10.2315L10.2315 6.52734"
            stroke="#56B683"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.37891 12.0831L10.2314 10.2314"
            stroke="#56B683"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10.2324 13.9352L10.6949 13.4727"
            stroke="#56B683"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M16.5226 12.3569C17.1475 11.7318 17.4986 10.8841 17.4986 10.0003C17.4986 9.11638 17.1475 8.26869 16.5226 7.6436L12.356 3.47693C11.7309 2.85203 10.8832 2.50098 9.99929 2.50098C9.11541 2.50098 8.26771 2.85203 7.64262 3.47693L3.47595 7.6436C2.85105 8.26869 2.5 9.11638 2.5 10.0003C2.5 10.8841 2.85105 11.7318 3.47595 12.3569L8.61846 17.5003H11.3801L16.5226 12.3569Z"
            stroke="#56B683"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
